export const FETCH_FORM_LAYOUT_DATA = "FETCH_FORM_LAYOUT_DATA";
export const UPDATE_DRAFT_FORM = "UPDATE_DRAFT_FORM";
export const FETCH_SAVED_FORM_LAYOUT_DATA = "FETCH_SAVED_FORM_LAYOUT_DATA";
export const SAVE_DRAFT_FORM = "SAVE_DRAFT_FORM";
export const SUBMIT_WARRANTY = "SUBMIT_WARRANTY";
export const FETCH_FORM_LAYOUT_DATA_SUCCESS = "FETCH_FORM_LAYOUT_DATA_SUCCESS";
export const FETCH_FORM_LAYOUT_DATA_FAILURE = "FETCH_FORM_LAYOUT_DATA_FAILURE";
export const UPDATE_DRAFT_FORM_SUCCESS = "UPDATE_DRAFT_FORM_SUCCESS";
export const UPDATE_DRAFT_FORM_FAILURE = "UPDATE_DRAFT_FORM_FAILURE";
export const FETCH_SAVED_FORM_LAYOUT_DATA_SUCCESS = "FETCH_SAVED_FORM_LAYOUT_DATA_SUCCESS";
export const FETCH_SAVED_FORM_LAYOUT_DATA_FAILURE = "FETCH_SAVED_FORM_LAYOUT_DATA_FAILURE";
export const FETCH_SAVED_FORM_DATA = "FETCH_SAVED_FORM_DATA";
export const FETCH_SAVED_FORM_DATA_AND_COPY = "FETCH_SAVED_FORM_DATA_AND_COPY";
export const FETCH_SAVED_FORM_DATA_SUCCESS = "FETCH_SAVED_FORM_DATA_SUCCESS";
export const SAVE_DRAFT_FORM_SUCCESS = "SAVE_DRAFT_FORM_SUCCESS";
export const SAVE_DRAFT_FORM_FAILURE = "SAVE_DRAFT_FORM_FAILURE";
export const UPDATE_WARRANTY_ID = "UPDATE_WARRANTY_ID";
export const REMOVE_FORM_LAYOUT_DATA = "REMOVE_FORM_LAYOUT_DATA";
export const MODIFY_FORM_DATA = "MODIFY_FORM_DATA";
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const GET_COUNTRY_CODE_ASYNC = "GET_COUNTRY_CODE_ASYNC";
export const GET_COUTRY_CODE = "GET_COUTRY_CODE";
export const SELECTED_ADDRESS = "SELECTED_ADDRESS";
export const SET_SELECTED_ADDRESS_ASYNC = "SET_SELECTED_ADDRESS_ASYNC";
export const UPDATE_BILLING_ADDRESS_STATUS = "UPDATE_BILLING_ADDRESS_STATUS";
export const GET_COUNTRY_CODE_MAILADDRESS_ASYNC = "GET_COUNTRY_CODE_MAILADDRESS_ASYNC";
export const GET_COUNTRY_CODE_BUILDINGADDR_ASYNC = "GET_COUNTRY_CODE_BUILDINGADDR_ASYNC";
export const GET_MAIL_ADDRESS_COUTRY_CODE = "GET_MAIL_ADDRESS_COUTRY_CODE";
export const GET_BUILDING_ADDRESS_COUTRY_CODE = "GET_BUILDING_ADDRESS_COUTRY_CODE";
export const MERGE_FORM_DATA_TO_STORE = "MERGE_FORM_DATA_TO_STORE";
export const VALIDATE_BUILDING_ADDRESS = "VALIDATE_BUILDING_ADDRESS";

export const CLEAR_ERROR = "CLEAR_ERROR";
export const FORM_LAYOUT_INITIAL_STATE = "FORM_LAYOUT_INITIAL_STATE";
export const FORM_LAYOUT_RESET_DATA = "FORM_LAYOUT_RESET_DATA";

export const FETCH_REVIEW_AND_PAY_FORM_DATA = "FETCH_REVIEW_AND_PAY_FORM_DATA";
export const SET_REVIEW_AND_PAY_TO_REDUX_STORE = "SET_REVIEW_AND_PAY_TO_REDUX_STORE";

export const UPDATE_NAVIGATION_MENU_STATUS = "UPDATE_NAVIGATION_MENU_STATUS";
export const CLEAR_NAVIGATION_MENU_STATUS = "CLEAR_NAVIGATION_MENU_STATUS";
export const ADD_FIELD_ID_TO_STORE = "ADD_FIELD_ID_TO_STORE";
export const REMOVE_FIELD_ID_FROM_STORE = "REMOVE_FIELD_ID_FROM_STORE";

export const FETCH_ERROR_RESPONSE = "FETCH_ERROR_RESPONSE";
export const FETCH_ERROR_RESPONSE_SUCCESS = "FETCH_ERROR_RESPONSE_SUCCESS";
export const TOGGLE_TECH_SUPPORT_POPUP = "TOGGLE_TECH_SUPPORT_POPUP";

export const SAVE_TEMPLATE = "SAVE_TEMPLATE";
export const SET_TEMPLATE_DATA = "SET_TEMPLATE_DATA";

export const SET_TEMPLATE_LIST = "SET_TEMPLATE_LIST";
export const FETCH_TEMPLATE_DATA = "FETCH_TEMPLATE_DATA";
export const FETCH_SAVED_TEMPLATES = "FETCH_SAVED_TEMPLATES";

export const DELETE_AND_UPDATE_TEMPLATE = "DELETE_AND_UPDATE_TEMPLATE";
export const ADD_NAV_MENUS_TO_STORE = "ADD_NAV_MENUS_TO_STORE";
export const UPDATE_PROJECT_DETAILS = "UPDATE_PROJECT_DETAILS";
export const ADD_TAB_DETAILS_TO_STORE = "ADD_TAB_DETAILS_TO_STORE";
export const GET_TEMPLATE_BY_ID = "GET_TEMPLATE_BY_ID";

export const UPDATE_MENU_COUNTER = "UPDATE_MENU_COUNTER";
export const CHECK_FORM_TYPE = "CHECK_FORM_TYPE";

export const FETCH_EDITABLE_STATUS = "FETCH_EDITABLE_STATUS";
export const FETCH_EDITABLE_STATUS_SUCCESS = "FETCH_EDITABLE_STATUS_SUCCESS";
export const AUTO_SAVE_FORM = "AUTO_SAVE_FORM";
export const ADD_NODE_DETAILS_TO_STORE = "ADD_NODE_DETAILS_TO_STORE";
export const API_RUNNING_STATUS = "API_RUNNING_STATUS";
export const LAYOUT_API_RUNNING_STATUS = "LAYOUT_API_RUNNING_STATUS";
export const UPDATE_SUBMIT_CLICK_STATUS = "UPDATE_SUBMIT_CLICK_STATUS";
export const CAPTURE_NAV_BUTTON_CLICK = "CAPTURE_NAV_BUTTON_CLICK";
export const GET_CONTRACTOR_FORM_SETTINGS = "GET_CONTRACTOR_FORM_SETTINGS";
export const SET_CONTRACTOR_FORM_SETTINGS = "SET_CONTRACTOR_FORM_SETTINGS";

export const GET_PROPERTY_MANAGER_LIST = "GET_PROPERTY_MANAGER_LIST";
export const UPDATE_PROPERTY_MANAGER_LIST = "UPDATE_PROPERTY_MANAGER_LIST";

export const SAVE_WARRANTY_VARIANCE = "SAVE_WARRANTY_VARIANCE";
export const SAVE_WARRANTY_VARIANCE_SUCCESS = "SAVE_WARRANTY_VARIANCE_SUCCESS";
export const SAVE_WARRANTY_VARIANCE_FAILURE = "SAVE_WARRANTY_VARIANCE_FAILURE";
export const CLEAR_WARRANTY_VARIANCE_DATA = "CLEAR_WARRANTY_VARIANCE_DATA";